import { render, staticRenderFns } from "./BreadcrumbBar.vue?vue&type=template&id=530cdace&scoped=true&"
import script from "./BreadcrumbBar.vue?vue&type=script&lang=js&"
export * from "./BreadcrumbBar.vue?vue&type=script&lang=js&"
import style0 from "./BreadcrumbBar.vue?vue&type=style&index=0&id=530cdace&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "530cdace",
  null
  
)

export default component.exports